import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { get, post } from "../../../services/apiService";
import Grid from "@mui/material/Grid2";
import BackdropLoader from "../../common/BackdropLoader";
import axios from "axios";
import i18next from "i18next";




const styles = {
  mainHeading: {
    fontSize: "32px",
    color: "black",
    textAlign: "center",
    fontFamily: "Tajawal-Bold",
    marginBottom: "20px",
  },
  subHeading: {
    fontSize: "24px",
    fontFamily: "Tajawal-Regular",
    textAlign: "left",
    marginBottom: "20px",
  },
  textField: {
    width: "100%",
    marginBottom: "20px",
    "& .MuiInputBase-root": {
      fontFamily: "Tajawal-Regular",
      fontSize: "16px",
      color: "#878584",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#878584",
    },
  },
  button: {
    background:
      "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
    color: "white",
    fontFamily: "Tajawal-Bold",
    padding: "12px 24px",
    textAlign: "center",
    width: "40%",
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    textTransform: "none",
    "&:hover": {
      background:
        "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
    },
  },
};

// Validation Schema using Yup
const validationSchema = Yup.object({
  // cardHolderName: Yup.string()
  //   .matches(/^[A-Za-z\s]+$/, "Card Holder name must only contain alphabets")
  //   .required("Card Holder name is required"),
  // cardNumber: Yup.string()
  //   .matches(/^\d{16}$/, "Card Number must be exactly 16 digits")
  //   .required("Card Number is required"),
  // expiryDate: Yup.string()
  //   .matches(
  //     /^(0[1-9]|1[0-2])\/?([0-9]{2})$/,
  //     "Expiry Date must be in MM/YY format"
  //   )
  //   .required("Expiry Date is required"),
  // cvv: Yup.string()
  //   .matches(/^\d{3}$/, "CVV must be exactly 3 digits")
  //   .required("CVV is required"),
});

const PaymentForm = ({ onPayNow }) => {
  const formik = useFormik({
    initialValues: {
      amount: "",
      currency: "",
      // cardHolderName: "",
      // cardNumber: "",
      // expiryDate: "",
      // cvv: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      await generateAPIMethods();
    },
  });

  const [availableMethods, setAvailableMethods] = useState([]);
  // const [methodUrl, setMethodUrl] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const onLoading = (isLoading) => {
    setIsLoading(isLoading)
  }

  const generateAPIMethods = useCallback(async () => {
    try {
      const object = {
        amount: Number(formik.values.amount),
        currency: formik.values.currency,
      };
      
      const response = await post(`payments/initiate`, object, {}, onLoading);
      if (response.status === 200 || response.status === 201) {
        setAvailableMethods(response.data.Data);
      }
    } catch (error) {}
  }, [formik.values.currency, formik.values.amount]);

  const userId = sessionStorage.getItem('userId');

  const convertAmountIntoKWT = (amountInSar) => {
    const amountInKWT = amountInSar / 12.16;
    return amountInKWT;
  }

  const executePayment = async (paymentObject, chargedAmount) => {
    try {
      const object = {
        PaymentMethodId: paymentObject.PaymentMethodId,
        "CurrencyIso": "SAR", 
        "Language": "en",
        InvoiceValue: convertAmountIntoKWT(Number(formik.values.amount)),
        CallBackUrl:`${process.env.REACT_APP_CALLBACK_URL}website-flow?tenantId=${userId}`,
        WebhookUrl:`${process.env.REACT_APP_CALLBACK_URL}website-flow/success-payment?tenantId=${userId}`,
        userId: userId,

      };
      const response = await post(`payments/execute`, object,{}, onLoading);
      if (response?.status === 200 || response?.status === 201) {
        // setMethodUrl(response?.data?.Data?.PaymentURL);/
       window.location.href= response.data.Data.PaymentURL

      }
    } catch (error) {}
  } 

  // const currencies = [
  //   { name: "Kuwait", code: "KWD" },
  //   { name: "Saudi Arabia", code: "SAR" },
  //   { name: "Bahrain", code: "BHD" },
  //   { name: "United Arab Emirates", code: "AED" },
  //   { name: "Qatar", code: "QAR" },
  //   { name: "Oman", code: "OMR" },
  //   { name: "Jordan", code: "JOD" },
  //   { name: "Egypt", code: "EGP" },
  // ];

  const onSecreenLoader = () => {

  }

  const fetchUserPlan = useCallback(async () => {
    try {
      const response = await get(`users/${userId}/plan`, {}, onSecreenLoader);
      if (response.status === 200) {
        if (!response.data) {
          // No plan found
        } else {
          // Plan found
              const priceResponse = await axios.get(`https://open.er-api.com/v6/latest/USD`);
              const usd1ToSAR = priceResponse.data.rates.SAR;
              const planAmountInSAR = usd1ToSAR * response.data.total;
              formik.setFieldValue('amount',planAmountInSAR)
              formik.setFieldValue('currency','SAR')
        }
      } else {
        console.warn('Unexpected status code:', response.status);
      }
    } catch (error) {
      // Handle API errors gracefully

    }
  },[userId, formik]);

  useEffect(()=>{
    if(userId) {
      fetchUserPlan()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userId])

  useEffect(()=>{
    if(formik.values.currency) {
      generateAPIMethods()
    }
  },[generateAPIMethods,formik.values.currency])
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        margin: "auto",
        padding: "20px",
      }}
    >
      {/* Main Heading */}
      {isLoading && <BackdropLoader/>}
      
      <Typography sx={styles.mainHeading}>{i18next.t('PAYMENT_PAGE_TEXT')}</Typography>

      {/* Sub Heading */}
      {/* <Typography sx={styles.subHeading}>Add your card details</Typography> */}

      {/* <form onSubmit={formik.handleSubmit}> */}
        {/* Card Number */}
        {/* <Typography
          sx={{
            mb: 1,

            fontSize: "20px",
            fontFamily: "Tajawal-Regular",
            color: "#121212",
          }}
        >
          Amount in SAR
        </Typography>
        <TextField
          sx={styles.textField}
          placeholder="Amount"
          disabled={true}
          variant="outlined"
          {...formik.getFieldProps("amount")}
          error={formik.touched.amount && Boolean(formik.errors.amount)}
          helperText={formik.touched.amount && formik.errors.amount}
        />

        <Typography
          sx={{
            mb: 1,

            fontSize: "20px",
            fontFamily: "Tajawal-Regular",
            color: "#121212",
          }}
        >
          Currency
        </Typography>
        <Select
          fullWidth
          labelId="country-select-label"
          displayEmpty
          value={formik.values.currency} // Ensure the value is controlled by formik
          onChange={(event) =>
          {
            formik.setFieldValue("currency", event.target.value)
          }
          } // Fixed the syntax
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: formik.errors.country ? "#d32f2f" : "grey", // Red if error, default otherwise
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: formik.errors.country ? "#d32f2f" : "grey", // Red on hover if error
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: formik.errors.country ? "#d32f2f" : "#1976d2", // if error on focused then color is red, otherwise blue
            },
          }}
        >
          <MenuItem value="" sx={{ color: "grey" }}>
            Select Currency
          </MenuItem>
          {currencies.map((item) => (
            <MenuItem key={item.code} value={item.code}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
        {formik.touched.country && formik.errors.country && (
          <FormHelperText
            sx={{
              color: "#d32f2f",
              marginLeft: "2%",
            }}
          >
            {formik.errors.country}
          </FormHelperText>
        )}

        <Box sx={{ textAlign: "center", marginTop: "30px" }}>
          <Button sx={styles.button} type="submit" fullWidth>
            Generate API Methods
          </Button>
        </Box> */}

        {/* Card Holder Name */}
        {/* <TextField
          sx={styles.textField}
          placeholder="Card Holder name"
          variant="outlined"
          {...formik.getFieldProps("cardHolderName")}
          error={
            formik.touched.cardHolderName &&
            Boolean(formik.errors.cardHolderName)
          }
          helperText={
            formik.touched.cardHolderName && formik.errors.cardHolderName
          }
        /> */}

        {/* <TextField
          sx={styles.textField}
          placeholder="Card Number"
          variant="outlined"
          {...formik.getFieldProps("cardNumber")}
          error={formik.touched.cardNumber && Boolean(formik.errors.cardNumber)}
          helperText={formik.touched.cardNumber && formik.errors.cardNumber}
        /> */}

        {/* Expiry Date and CVV */}
        {/* <Grid container spacing={2}>
          <Grid item size={{ xs: 6 }}>
            <TextField
              sx={styles.textField}
              placeholder="MM/YY"
              variant="outlined"
              {...formik.getFieldProps("expiryDate")}
              error={
                formik.touched.expiryDate && Boolean(formik.errors.expiryDate)
              }
              helperText={formik.touched.expiryDate && formik.errors.expiryDate}
            />
          </Grid>
          <Grid item size={{ xs: 6 }}>
            <TextField
              sx={styles.textField}
              placeholder="CVV"
              variant="outlined"
              {...formik.getFieldProps("cvv")}
              error={formik.touched.cvv && Boolean(formik.errors.cvv)}
              helperText={formik.touched.cvv && formik.errors.cvv}
            />
          </Grid>
        </Grid> */}

        {/* Pay Now Button */}
        {/* <Box sx={{ textAlign: "center", marginTop: "30px" }}>
          <Button sx={styles.button} type="submit" fullWidth>
            Pay Now
          </Button>
        </Box> */}
      {/* </form> */}
      {/* sx={{xl:3, lg:3, md:6, sm:6, xs:12}} */}
      <Box sx={{mt:5}}>
        <Grid container spacing={4}>
          {availableMethods?.map((method, index) => (
            <Grid item key={index} size={{xl:3, lg:4, md:6, sm:6, xs:12}} >
              <Card sx={{ p: 2, cursor:"pointer", width:"270px", height:"260px" }} onClick={()=>executePayment(method, (method.ServiceCharge + method.TotalAmount).toFixed(2))}>
                <CardContent>
                  {/* First Row - Payment Method & Image */}
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item sx={{width:"74%"}}>
                      <Typography variant="h6">
                        {method.PaymentMethodEn}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <img
                        src={method.ImageUrl}
                        alt={method.PaymentMethodEn}
                        width={50}
                      />
                    </Grid>
                  </Grid>

                  {/* Second Row - Service Charges */}
                  <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                    <Typography variant="body1" fontWeight="bold">
                      {i18next.t("PAYMENT_SERVICE_CHARGES")}:
                    </Typography>
                    <Typography variant="body1">
                      {method.ServiceCharge.toFixed(2)} {method.PaymentCurrencyIso}
                    </Typography>
                  </Grid>

                  {/* Third Row - Subtotal */}
                  <Grid container justifyContent="space-between" sx={{ mt: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                     {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_SUBTOTAL")}:
                    </Typography>
                    <Typography variant="body1">
                      {method.TotalAmount.toFixed(2)} {method.PaymentCurrencyIso}
                    </Typography>
                  </Grid>

                  {/* Fourth Row - Total (Service Charges + Subtotal) */}
                  <Grid container justifyContent="space-between" sx={{ mt: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                    {i18next.t("PAYMENT_PAGE_SUMMARY_ITEM_TOTAL")}:
                    </Typography>
                    <Typography variant="body1" color="primary">
                      {(method.ServiceCharge + method.TotalAmount).toFixed(2)}{" "}
                      {method.PaymentCurrencyIso}
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PaymentForm;
